(() => {
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  const isBackNavigation = () => {
    const nav = performance.getEntriesByType('navigation')[0];
    return Boolean(nav && (nav.type === 'back_forward' || nav.type === 'back'));
  };

  const stripProductCardHash = () => {
    const hash = window.location.hash;
    if (!hash || !hash.startsWith('#product-card-')) return;
    const url = `${window.location.pathname}${window.location.search}`;
    window.history.replaceState(window.history.state, '', url);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  };

  const applyBackScrollTop = () => {
    stripProductCardHash();
    requestAnimationFrame(() => {
      requestAnimationFrame(scrollToTop);
    });
  };

  const shouldRestoreTop = (event) => Boolean(event?.persisted || isBackNavigation());

  window.addEventListener('pageshow', (event) => {
    if (!shouldRestoreTop(event)) return;
    applyBackScrollTop();
  });

  if (isBackNavigation()) {
    applyBackScrollTop();
  }
})();
